export enum FORM_NAME {
  CREATE_NOTIFICATION_REMIND = 'CREATE_NOTIFICATION_REMIND',
  UPDATE_NOTIFICATION_REMIND = 'UPDATE_NOTIFICATION_REMIND',
}
